import { connect } from 'react-redux'
import ChatPanel from './ChatPanel'
import { getChat } from './chat.actions'
import { saveTextViewedAudit, updateReviewGoal } from '../MediaPlayer/mediaPlayer.actions'
import { getHasReviewGoal } from '../MediaPlayer/mediaPlayer.selectors'


// Called each time the store is updated. It receives the entire store state, and should return an object of data this component needs; which in this case is the text
const mapStateToProps = ({
  media: {
    chat: { text },
    main,
  },
}) => {
  return {
    data: text.data,
    hasReviewGoal: getHasReviewGoal(main),
    contactTz: main.contact.data.tz,
  }
}

// This one defines the functions that can be called by the component.
// It receives the dispatch function, and should return an object of functions that can be called by the component
const mapDispatchToProps = dispatch => ({
  async requestChat(contactId) {
    await dispatch(getChat(contactId))
  },
  async auditTextViewed(contactId) {
    await dispatch(saveTextViewedAudit(contactId))
  },
  async completeReviewGoal(contactId, goalId, userId) {
    await dispatch(updateReviewGoal(contactId, goalId, { complete: true, personId: userId }))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(ChatPanel)
